import { render, staticRenderFns } from "./home3.vue?vue&type=template&id=6155da4a&"
import script from "./home3.vue?vue&type=script&lang=js&"
export * from "./home3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports